(function () {
  var MAIN_HANDLE   = 'the-social-security-handbook';
  var MAIN_VARIANTS = [57457531978108];
  var MAIN_PLAN     = null;

  var BONUS_VARIANT_IDS = [57376728908156, 57376728940924, 57376728973692, 57376729006460];
  var BONUS_TOGGLE_IDS  = ['ssmc-bonus-toggle-1', 'ssmc-bonus-toggle-2', 'ssmc-bonus-toggle-3', 'ssmc-bonus-toggle-4'];
  var BONUS_OPTOUT_PREFIX = 'ssmc_bonus_optout_';

  var ADDON_ENABLED = true;
  var ADDON_HANDLE  = 'the-retirement-dispatch';
  var ADDON_VARIANT = 57383150453116;
  var ADDON_PLAN    = 832364347772;
  var OPTOUT_KEY    = 'ssmc_dispatch_optout';

  // 30-day access. Its own digital product since the book went physical.
  var ACCESS_ENABLED    = true;
  var ACCESS_HANDLE     = 'money-code-access';
  var ACCESS_VARIANT    = 57457468473724;
  var ACCESS_PLAN       = 832389480828;
  var ACCESS_OPTOUT_KEY = 'ssmc_access_optout';
  var ACCESS_TITLE      = 'Digital Access';
  var ACCESS_DESC       = 'Your instant digital edition - start reading today while the printed book is on its way - kept in your account so you can re-download it any time. First 30 days free, then $2.99/30 days. Cancel anytime.';

  var origFetch = window.fetch;

  function refresh(handle, cb) {
    if (!handle) return;
    origFetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var ids = [];
        if (p && p.variants) { p.variants.forEach(function (x) { if (x && x.id) ids.push(x.id); }); }
        var g = p && p.selling_plan_groups && p.selling_plan_groups[0];
        var s = g && g.selling_plans && g.selling_plans[0];
        cb(ids, s && s.id);
      }).catch(function () {});
  }
  refresh(MAIN_HANDLE, function (v, p) { if (v && v.length) MAIN_VARIANTS = v; MAIN_PLAN = p || null; });
  if (ADDON_ENABLED) refresh(ADDON_HANDLE, function (v, p) { if (v && v.length) ADDON_VARIANT = v[0]; if (p) ADDON_PLAN = p; });
  if (ACCESS_ENABLED) refresh(ACCESS_HANDLE, function (v, p) { if (v && v.length) ACCESS_VARIANT = v[0]; if (p) ACCESS_PLAN = p; });

  /* ---------- weekly dispatch toggle (rendered by the theme) ---------- */
  function optedOut(){ try { return sessionStorage.getItem(OPTOUT_KEY) === '1'; } catch(e){ return false; } }
  function applyAddonPreselect(){
    var box = document.getElementById('ssmc-addon');
    var cb  = document.getElementById('ssmc-addon-toggle');
    if (!box || !cb) return;
    var want = !optedOut();
    if (cb.checked !== want) cb.checked = want;
    box.classList.toggle('is-selected', want);
    if (!cb.__wired) {
      cb.__wired = true;
      cb.addEventListener('change', function () {
        box.classList.toggle('is-selected', cb.checked);
        try {
          if (cb.checked) sessionStorage.removeItem(OPTOUT_KEY);
          else sessionStorage.setItem(OPTOUT_KEY, '1');
        } catch (e) {}
      });
    }
  }

  /* ---------- 30-day access toggle (injected above the weekly one) ---------- */
  function accessOptedOut(){ try { return sessionStorage.getItem(ACCESS_OPTOUT_KEY) === '1'; } catch(e){ return false; } }
  function buildAccessBox(){
    if (!ACCESS_ENABLED) return null;
    var existing = document.getElementById('ssmc-access');
    if (existing) return existing;
    var anchor = document.getElementById('ssmc-addon');
    if (!anchor || !anchor.parentNode) return null;

    var box = document.createElement('div');
    box.id = 'ssmc-access';
    box.className = 'hn-addon';
    box.style.marginBottom = '14px';

    var label = document.createElement('label');
    label.className = 'hn-addon__inner';
    label.setAttribute('for', 'ssmc-access-toggle');

    var cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.id = 'ssmc-access-toggle';
    cb.className = 'hn-addon__cb';
    cb.checked = true;

    var text = document.createElement('span');
    text.className = 'hn-addon__text';
    var t = document.createElement('span');
    t.className = 'hn-addon__title';
    t.textContent = ACCESS_TITLE;
    var d = document.createElement('span');
    d.className = 'hn-addon__desc';
    d.textContent = ACCESS_DESC;
    text.appendChild(t);
    text.appendChild(d);

    var mark = document.createElement('span');
    mark.className = 'hn-addon__mark';
    mark.setAttribute('aria-hidden', 'true');

    label.appendChild(cb);
    label.appendChild(text);
    label.appendChild(mark);
    box.appendChild(label);

    anchor.parentNode.insertBefore(box, anchor);
    return box;
  }
  function applyAccessPreselect(){
    var box = buildAccessBox();
    if (!box) return;
    var cb = document.getElementById('ssmc-access-toggle');
    if (!cb) return;
    var want = !accessOptedOut();
    if (cb.checked !== want) cb.checked = want;
    box.classList.toggle('is-selected', want);
    if (!cb.__wired) {
      cb.__wired = true;
      cb.addEventListener('change', function () {
        box.classList.toggle('is-selected', cb.checked);
        try {
          if (cb.checked) sessionStorage.removeItem(ACCESS_OPTOUT_KEY);
          else sessionStorage.setItem(ACCESS_OPTOUT_KEY, '1');
        } catch (e) {}
      });
    }
  }

  applyAddonPreselect();
  applyAccessPreselect();

  function bonusOptedOut(idx){ try { return sessionStorage.getItem(BONUS_OPTOUT_PREFIX + idx) === '1'; } catch(e){ return false; } }
  function applyBonusPreselect(){
    BONUS_TOGGLE_IDS.forEach(function (id, idx) {
      var cb = document.getElementById(id);
      if (!cb) return;
      var row = cb.closest('.hn-bonus-row');
      var want = !bonusOptedOut(idx);
      if (cb.checked !== want) cb.checked = want;
      if (row) row.classList.toggle('is-off', !want);
      if (!cb.__wired) {
        cb.__wired = true;
        cb.addEventListener('change', function () {
          if (row) row.classList.toggle('is-off', !cb.checked);
          try {
            if (cb.checked) sessionStorage.removeItem(BONUS_OPTOUT_PREFIX + idx);
            else sessionStorage.setItem(BONUS_OPTOUT_PREFIX + idx, '1');
          } catch (e) {}
        });
      }
    });
  }
  applyBonusPreselect();
  document.addEventListener('DOMContentLoaded', function () { applyAddonPreselect(); applyAccessPreselect(); applyBonusPreselect(); });
  setTimeout(function () { applyAddonPreselect(); applyAccessPreselect(); applyBonusPreselect(); }, 600);
  setTimeout(function () { applyAccessPreselect(); }, 1800);

  function addonWanted(){
    if (!ADDON_ENABLED) return false;
    var el = document.getElementById('ssmc-addon-toggle');
    return el ? el.checked : !optedOut();
  }
  function accessWanted(){
    if (!ACCESS_ENABLED) return false;
    var el = document.getElementById('ssmc-access-toggle');
    return el ? el.checked : !accessOptedOut();
  }
  function bonusWanted(idx){
    var el = document.getElementById(BONUS_TOGGLE_IDS[idx]);
    return el ? el.checked : !bonusOptedOut(idx);
  }
  function isMain(id){ return MAIN_VARIANTS.indexOf(id) >= 0; }
  function planFor(id){
    if (isMain(id)) return MAIN_PLAN;
    if (ADDON_ENABLED && id === ADDON_VARIANT) return ADDON_PLAN;
    if (ACCESS_ENABLED && id === ACCESS_VARIANT) return ACCESS_PLAN;
    return null;
  }

  function refreshCartUI() {
    var cartItemsComponent = document.querySelector('cart-items-component');
    if (cartItemsComponent && typeof cartItemsComponent.fetchCartData === 'function') {
      cartItemsComponent.fetchCartData();
    }
  }

  function flatten(body){
    var list = [];
    if (body instanceof FormData) {
      var rows = {};
      body.forEach(function (v, k) {
        if (k.slice(0, 6) !== 'items[') return;
        var close = k.indexOf(']');
        if (close < 0) return;
        var i = k.slice(6, close);
        rows[i] = rows[i] || {};
        if (k.slice(-4) === '[id]') rows[i].id = parseInt(v, 10);
        if (k.slice(-10) === '[quantity]') rows[i].quantity = parseInt(v, 10);
      });
      Object.keys(rows).forEach(function (i) { if (rows[i].id) list.push(rows[i]); });
      if (!list.length && body.get('id')) {
        list.push({ id: parseInt(body.get('id'), 10), quantity: parseInt(body.get('quantity') || 1, 10) });
      }
    } else if (typeof body === 'string' && body.charAt(0) === '{') {
      var j = JSON.parse(body);
      if (j.items && j.items.length) {
        j.items.forEach(function (it) { list.push({ id: parseInt(it.id, 10), quantity: parseInt(it.quantity || 1, 10) }); });
      } else if (j.id) {
        list.push({ id: parseInt(j.id, 10), quantity: parseInt(j.quantity || 1, 10) });
      }
    }
    return list;
  }
  function sectionsOf(body){
    var out = { sections: null, sections_url: null };
    try {
      if (body instanceof FormData) {
        out.sections = body.get('sections'); out.sections_url = body.get('sections_url');
      } else if (typeof body === 'string' && body.charAt(0) === '{') {
        var j = JSON.parse(body); out.sections = j.sections; out.sections_url = j.sections_url;
      }
    } catch (e) {}
    return out;
  }

  window.fetch = function (u, o) {
    var url = (typeof u === 'string') ? u : (u && u.url) || '';
    if (url.indexOf('/cart/add') < 0 || !o || !o.body) return origFetch.apply(this, arguments);

    var list;
    try { list = flatten(o.body); } catch (e) { return origFetch.apply(this, arguments); }
    if (!list.length) return origFetch.apply(this, arguments);

    var hasMain = list.some(function (it) { return isMain(it.id); });
    if (!hasMain) return origFetch.apply(this, arguments);

    var mainItem = list.filter(function (it) { return isMain(it.id); })[0];
    var secs = sectionsOf(o.body);

    var addonExtra = [];
    if (addonWanted() && ADDON_VARIANT && !list.some(function (it) { return it.id === ADDON_VARIANT; })) {
      addonExtra.push({ id: ADDON_VARIANT, quantity: 1 });
    }

    var accessExtra = [];
    if (accessWanted() && ACCESS_VARIANT && !list.some(function (it) { return it.id === ACCESS_VARIANT; })) {
      accessExtra.push({ id: ACCESS_VARIANT, quantity: 1 });
    }

    var bonusExtra = [];
    BONUS_VARIANT_IDS.forEach(function (id, idx) {
      if (bonusWanted(idx) && !list.some(function (it) { return it.id === id; })) bonusExtra.push({ id: id, quantity: 1 });
    });

    function buildItem(it) {
      var obj = { id: it.id, quantity: it.quantity || 1 };
      var plan = planFor(it.id);
      if (plan) obj.selling_plan = plan;
      return obj;
    }

    // The cart renders newest-first, so push in reverse of the wanted display order.
    // Wanted display, top to bottom:
    //   Handbook, Claiming Age Calculator, Tax-Free Blueprint, Call SSA Script Pack,
    //   12-Month Pre-Claiming Countdown, Digital Edition, Social Security Weekly.
    // Bonuses go in BONUS_VARIANT_IDS order (Countdown first, Calculator last) behind
    // the two subscriptions, and the book is pushed last so it lands on top.
    var items = [];
    addonExtra.forEach(function (it) { items.push(buildItem(it)); });
    accessExtra.forEach(function (it) { items.push(buildItem(it)); });
    bonusExtra.forEach(function (it) { items.push(buildItem(it)); });
    items.push(buildItem(mainItem));

    var payload = { items: items };
    if (secs.sections) { payload.sections = secs.sections; payload.sections_url = secs.sections_url || window.location.pathname; }

    return origFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (realResponse) {
      try {
        realResponse.clone().json().catch(function () {}).then(function () { refreshCartUI(); });
      } catch (e) {}
      return realResponse;
    });
  };
})();
